export default "__VITE_ASSET__ChpEfXt0__"